import { useMemo } from 'react';
import type { LifecycleStateFilterDto } from '@terra/shared-dto-types';
import type { TargetTypeType } from '@terra/shared-schemas-orchestrator';
import { resolveSelectableSignalTotal } from '../utils/signal-archive-selection';
import { useSignalCounts, type SignalCountsFilters } from './useSignalCounts';

export function useSelectableSignalTotal({
  displayedTotalCount,
  lifecycleQueryParam,
  targetId,
  targetType,
  endpointId,
  surfaceAssetEntityId,
  surfaceAssetKind,
  countsFilters,
  includeApplicationLevelGroup,
  enabled,
}: {
  displayedTotalCount: number;
  lifecycleQueryParam?: LifecycleStateFilterDto;
  targetId?: string;
  targetType?: TargetTypeType;
  endpointId?: string;
  surfaceAssetEntityId?: string;
  surfaceAssetKind?: string;
  countsFilters: SignalCountsFilters;
  includeApplicationLevelGroup?: boolean;
  enabled: boolean;
}) {
  const shouldCountMutableSignals = lifecycleQueryParam === 'all';
  const mutableCountsFilters = useMemo(
    (): SignalCountsFilters => ({
      ...countsFilters,
      lifecycleState: 'active',
    }),
    [countsFilters],
  );
  const { data: mutableCountsData } = useSignalCounts({
    targetId,
    targetType,
    endpointId,
    surfaceAssetEntityId,
    surfaceAssetKind,
    filters: mutableCountsFilters,
    includeApplicationLevelGroup,
    enabled: enabled && shouldCountMutableSignals,
  });

  return resolveSelectableSignalTotal({
    displayedTotalCount,
    lifecycleState: lifecycleQueryParam,
    mutableTotalCount: mutableCountsData?.total,
  });
}
